import * as ambassadorWixCalendarV3EventsView from './calendar-v3-events-view-event-views.http.js';
import * as ambassadorWixCalendarV3EventsViewTypes from './calendar-v3-events-view-event-views.types.js';
import * as ambassadorWixCalendarV3EventsViewUniversalTypes from './calendar-v3-events-view-event-views.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getEventsView(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixCalendarV3EventsViewUniversalTypes.GetEventsViewRequest,
  ambassadorWixCalendarV3EventsViewTypes.GetEventsViewRequest,
  ambassadorWixCalendarV3EventsViewUniversalTypes.GetEventsViewResponse,
  ambassadorWixCalendarV3EventsViewTypes.GetEventsViewResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixCalendarV3EventsView.getEventsView(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/events/view',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  EventsView as EventsViewOriginal,
  EventsViewProjectionUpdated as EventsViewProjectionUpdatedOriginal,
  EventsViewProjectionUpdatedTypeOneOf as EventsViewProjectionUpdatedTypeOneOfOriginal,
  EventAddedOrUpdated as EventAddedOrUpdatedOriginal,
  Event as EventOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  ZonedDate as ZonedDateOriginal,
  RecurrenceType as RecurrenceTypeOriginal,
  RecurrenceTypeWithLiterals as RecurrenceTypeWithLiteralsOriginal,
  RecurrenceRule as RecurrenceRuleOriginal,
  Frequency as FrequencyOriginal,
  FrequencyWithLiterals as FrequencyWithLiteralsOriginal,
  Day as DayOriginal,
  DayWithLiterals as DayWithLiteralsOriginal,
  Transparency as TransparencyOriginal,
  TransparencyWithLiterals as TransparencyWithLiteralsOriginal,
  Location as LocationOriginal,
  LocationType as LocationTypeOriginal,
  LocationTypeWithLiterals as LocationTypeWithLiteralsOriginal,
  Resource as ResourceOriginal,
  Role as RoleOriginal,
  RoleWithLiterals as RoleWithLiteralsOriginal,
  Participants as ParticipantsOriginal,
  Participant as ParticipantOriginal,
  ParticipantsStatus as ParticipantsStatusOriginal,
  ParticipantsStatusWithLiterals as ParticipantsStatusWithLiteralsOriginal,
  ConferencingDetails as ConferencingDetailsOriginal,
  ProviderType as ProviderTypeOriginal,
  ProviderTypeWithLiterals as ProviderTypeWithLiteralsOriginal,
  OnlineMeetingInfo as OnlineMeetingInfoOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Provider as ProviderOriginal,
  ProviderProviderInfoOneOf as ProviderProviderInfoOneOfOriginal,
  Field as FieldOriginal,
  FieldWithLiterals as FieldWithLiteralsOriginal,
  Permission as PermissionOriginal,
  CommonIdentificationData as CommonIdentificationDataOriginal,
  CommonIdentificationDataIdOneOf as CommonIdentificationDataIdOneOfOriginal,
  IdentityType as IdentityTypeOriginal,
  IdentityTypeWithLiterals as IdentityTypeWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  EventRemoved as EventRemovedOriginal,
  EventsViewExtended as EventsViewExtendedOriginal,
  GetEventsViewRequest as GetEventsViewRequestOriginal,
  GetEventsViewResponse as GetEventsViewResponseOriginal,
  ExtendEventsViewRequest as ExtendEventsViewRequestOriginal,
  ExtendEventsViewResponse as ExtendEventsViewResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './calendar-v3-events-view-event-views.types.js';
